export const formatConsultationDate = (date) => {
  const d = date ? new Date(date) : new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.toLocaleDateString("en-IE", {
    day: "numeric",
    month: "long",
    year: "numeric",
  })}, ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
